import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { WelcomePageLayout } from '@thinknet-gmbh/platform-common-ui';
import { MemberTypesEnum, PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';
import { useUpdateCurrentProfile } from 'src/hooks/profiles/update-current-profile.hook';
import { useUpdateCurrentCompany } from 'src/hooks/companies/update-current-company.hook';

import { IFormData } from './welcome.interfaces';

const WelcomePage = () => {
  const { t } = useTranslation(['auth', 'common', 'customers']);
  const navigate = useNavigate();
  const [data, setData] = useState<IFormData | null>(null);

  const updateCurrentProfile = useUpdateCurrentProfile();
  const updateCurrentCompany = useUpdateCurrentCompany();
  const { member, loading } = useGetCurrentMemberAccount();

  useEffect(() => {
    if (!loading) {
      setData({
        firstName: member.profile.firstName,
        lastName: member.profile.lastName,
        phoneNumber: member.profile.phoneNumber,
        companyName: member.ownerCompany.name,
        address: {
          street: member.ownerCompany.street,
          zipCode: member.ownerCompany.zipCode,
          houseNumber: member?.ownerCompany?.houseNumber,
          city: member.ownerCompany.city,
          country: member.ownerCompany.country,
        },
      });
    }
  }, [loading, member, navigate]);

  const isInternal = member?.type === MemberTypesEnum.INTERNAL;

  const onSubmitData = () => {
    if (!isInternal) {
      updateCurrentProfile({
        variables: {
          payload: {
            firstName: data?.firstName,
            lastName: data?.lastName,
            phoneNumber: data?.phoneNumber,
          },
        },
      });

      updateCurrentCompany({
        variables: { payload: { name: data?.companyName, ...data?.address } },
      });
    }
    navigate(ROUTES.dashboard);
  };

  return (
    <WelcomePageLayout
      t={t}
      module={PlatformModulesEnum.YUU_HR_MODULE}
      data={data}
      setData={setData}
      onSubmitData={onSubmitData}
      isInternal={isInternal}
    />
  );
};

export default WelcomePage;
